import WsCampaignList from './WsCampaignList'
import { WsCampaignsEdit } from './WsCampaignsEdit'
import { WsCampaignsCreate } from './WsCampaignsCreate'

export default {
  create: WsCampaignsCreate,
  edit: WsCampaignsEdit,
  list: WsCampaignList,
}
